/**
 * Clean & Box draft PDP preview v5
 * - Loads mdb-pdp-main. (mdb-pdp-main-v2 was a byte-identical clone whose
 * only difference was rendering an identical copy of the draft-rest snippet;
 * both removed 2026-09-21, and asking the Section Rendering API for a section
 * that no longer exists risks erroring the whole request.)
 * - DOM enhance: fit→buybox, value/FAQ 2-col placeholders, float clear
 * sync-bust: 2026-08-03-preview-v5-layout
 */
(function () {
  function injectSilkType() {
    if (document.getElementById('mdb-pdp-silk-type')) return;
    if (!document.querySelector('.mdb-pdp, [data-mdb-pdp-root], #mdb-pdp-preview-root')) return;
    var style = document.createElement('style');
    style.id = 'mdb-pdp-silk-type';
    style.textContent =
      '.mdb-pdp{--mdb-pdp-copy-size:1.5rem;--mdb-pdp-copy-leading:calc(1 + 0.8 / var(--font-body-scale, 1));}' +
      '.mdb-pdp-fit__item,.mdb-pdp-fit__silk p,.mdb-pdp-social__quote p,.mdb-pdp-value__list li,' +
      '.mdb-pdp-stats__label,.mdb-pdp-faq .mdb-pdp-faq__body{' +
      'font-size:var(--mdb-pdp-copy-size)!important;' +
      'line-height:var(--mdb-pdp-copy-leading)!important;}' +
      '.mdb-pdp-faq .h2,.mdb-pdp-faq h2,.mdb-pdp-faq summary{' +
      'font-family:var(--font-body-family)!important;' +
      'font-style:var(--font-body-style)!important;' +
      'font-weight:600!important;letter-spacing:normal!important;}' +
      '.mdb-pdp-faq summary{font-size:var(--mdb-pdp-copy-size)!important;' +
      'line-height:var(--mdb-pdp-copy-leading)!important;}' +
      '@media screen and (min-width:750px){.mdb-pdp{--mdb-pdp-copy-size:1.6rem;}}';
    (document.head || document.documentElement).appendChild(style);
  }

  var params = new URLSearchParams(window.location.search || '');
  var view = (params.get('view') || '').toLowerCase();
  var flag = (params.get('mdb_pdp') || '').toLowerCase();
  var wantsDraft =
    view === 'clean-box-draft' ||
    view.indexOf('clean-box') !== -1 ||
    flag === 'draft' ||
    flag === '1';

  if (!wantsDraft || !/\/products\//.test(window.location.pathname)) {
    function bootTypeOnly() {
      injectSilkType();
      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(injectSilkType);
        obs.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () {
          try {
            obs.disconnect();
          } catch (e) {}
        }, 12000);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootTypeOnly);
    else bootTypeOnly();
    return;
  }

  var alreadyStarted = !!window.__mdbPdpPreviewStarted;
  window.__mdbPdpPreviewStarted = true;

  function assetUrl(filename) {
    var sample = document.querySelector(
      'script[src*="/cdn/shop/t/"][src*="/assets/"], link[href*="/cdn/shop/t/"][href*="/assets/"]'
    );
    if (sample) {
      var href = sample.src || sample.href;
      return href.replace(/\/assets\/[^/?#]+.*/, '/assets/' + filename);
    }
    return '/cdn/shop/t/28/assets/' + filename;
  }

  function ensureStylesheet(filename) {
    if (document.querySelector('link[href*="/assets/' + filename + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = assetUrl(filename);
    document.head.appendChild(link);
  }

  function ensureScript(filename) {
    return new Promise(function (resolve) {
      if (filename === 'mdb-pdp.js' && typeof window.mdbPdpInit === 'function') {
        resolve();
        return;
      }
      var existing = document.querySelector('script[src*="/assets/' + filename + '"]');
      if (existing) {
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', function () {
          resolve();
        });
        if (existing.dataset.loaded === 'true') resolve();
        return;
      }
      var s = document.createElement('script');
      s.src = assetUrl(filename);
      s.defer = true;
      s.onload = function () {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = function () {
        resolve();
      };
      document.head.appendChild(s);
    });
  }

  function enhanceLayout(root) {
    if (!root || root.getAttribute('data-mdb-layout-enhanced') === '1') return;
    root.setAttribute('data-mdb-layout-enhanced', '1');

    /* 1) Move standalone fit into buybox info (under ATC) */
    var info = root.querySelector('.mdb-pdp-buybox__info');
    var atc = root.querySelector('[data-mdb-pdp-buybox-atc]');
    var fitSection = root.querySelector('section.mdb-pdp-fit:not(.mdb-pdp-fit--buybox)');
    if (info && atc && fitSection && !info.querySelector('.mdb-pdp-fit--buybox')) {
      var fitInner = document.createElement('div');
      fitInner.className = 'mdb-pdp-fit mdb-pdp-fit--buybox';
      var page = fitSection.querySelector('.mdb-pdp__page-width') || fitSection;
      while (page.firstChild) fitInner.appendChild(page.firstChild);
      atc.insertAdjacentElement('afterend', fitInner);
      fitSection.parentNode.removeChild(fitSection);
    }

    /* 2) Everything included → copy | gown-in-box */
    var value = root.querySelector('section.mdb-pdp-value');
    if (value && !value.querySelector('.mdb-pdp-value__grid')) {
      var vPage = value.querySelector('.mdb-pdp__page-width') || value;
      var vTitle = vPage.querySelector('h2');
      var vList = vPage.querySelector('.mdb-pdp-value__list');
      if (vTitle && vList) {
        var vGrid = document.createElement('div');
        vGrid.className = 'mdb-pdp__page-width mdb-pdp-value__grid';
        var vCopy = document.createElement('div');
        vCopy.className = 'mdb-pdp-value__copy';
        vTitle.classList.add('mdb-pdp-value__title');
        vCopy.appendChild(vTitle);
        vCopy.appendChild(vList);
        var vMedia = document.createElement('aside');
        vMedia.className = 'mdb-pdp-value__media';
        vMedia.setAttribute('aria-label', 'Gown in dress box');
        vMedia.innerHTML =
          '<div class="mdb-pdp-value__frame"><div class="mdb-pdp-placeholder mdb-pdp-value__placeholder">' +
          '[PLACEHOLDER: final image — gown packed in acid-free dress box with tissue]' +
          '</div></div>';
        vGrid.appendChild(vCopy);
        vGrid.appendChild(vMedia);
        value.innerHTML = '';
        value.appendChild(vGrid);
      }
    }

    /* 3) FAQ → questions | video placeholder */
    var faq = root.querySelector('section.mdb-pdp-faq');
    if (faq && !faq.querySelector('.mdb-pdp-faq__grid')) {
      var fPage = faq.querySelector('.mdb-pdp__page-width') || faq;
      var kids = Array.prototype.slice.call(fPage.childNodes);
      var fGrid = document.createElement('div');
      fGrid.className = 'mdb-pdp__page-width mdb-pdp-faq__grid';
      var fCopy = document.createElement('div');
      fCopy.className = 'mdb-pdp-faq__copy';
      kids.forEach(function (n) {
        fCopy.appendChild(n);
      });
      var title = fCopy.querySelector('h2');
      if (title) title.classList.add('mdb-pdp-faq__title');
      var fMedia = document.createElement('aside');
      fMedia.className = 'mdb-pdp-faq__media';
      fMedia.setAttribute('aria-label', 'FAQ video');
      fMedia.innerHTML =
        '<div class="mdb-pdp-faq__video">' +
        '<div class="mdb-pdp-placeholder mdb-pdp-faq__video-placeholder">' +
        '[PLACEHOLDER: short video answering common questions — tiers, process, service area, silk, instalments]' +
        '</div>' +
        '<p class="mdb-pdp-faq__video-caption">Video walkthrough of the questions most brides ask.</p>' +
        '</div>';
      fGrid.appendChild(fCopy);
      fGrid.appendChild(fMedia);
      faq.innerHTML = '';
      faq.appendChild(fGrid);
    }
  }

  function mount(html) {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return false;

    document.documentElement.classList.add('mdb-pdp-preview');
    document.body.classList.add('mdb-pdp-preview');

    var banner = document.createElement('div');
    banner.setAttribute('role', 'status');
    banner.style.cssText =
      'background:#1a1a1a;color:#efecec;font:600 12px/1.4 system-ui,sans-serif;padding:0.65rem 1rem;text-align:center;position:sticky;top:0;z-index:40;';
    banner.textContent =
      'Draft PDP preview — not assigned to live products. Remove ?view=clean-box-draft to see the live page.';

    var wrap = document.createElement('div');
    wrap.id = 'mdb-pdp-preview-root';
    wrap.innerHTML = html;

    main.innerHTML = '';
    main.appendChild(banner);
    main.appendChild(wrap);

    Array.prototype.slice.call(wrap.querySelectorAll('link[rel="stylesheet"], style')).forEach(function (node) {
      document.head.appendChild(node);
    });

    enhanceLayout(wrap);
    injectSilkType();
    return true;
  }

  function run() {
    ensureStylesheet('section-mdb-pdp.css');
    ensureStylesheet('section-mdb-pdp-type-v2.css');
    ensureStylesheet('section-mdb-pdp-layout-v2.css');
    ensureStylesheet('section-mdb-pdp-fit-v3.css');
    ensureStylesheet('component-price.css');

    /* If an older preview already mounted, only enhance DOM + clear floats */
    if (alreadyStarted || document.getElementById('mdb-pdp-preview-root')) {
      var existing = document.getElementById('mdb-pdp-preview-root') || document.getElementById('MainContent');
      if (existing) enhanceLayout(existing);
      injectSilkType();
      ensureScript('mdb-pdp-float-clear.js');
      ensureScript('mdb-g-badge-align-v2.js');
      if (typeof window.mdbPdpInit === 'function') window.mdbPdpInit();
      return;
    }

    var url = window.location.pathname + '?sections=mdb-pdp-main';
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var html = (data && data['mdb-pdp-main']) || '';
        if (!html) throw new Error('mdb-pdp-main section missing on theme');
        if (!mount(html)) throw new Error('MainContent missing');
        return Promise.all([
          ensureScript('product-form.js'),
          ensureScript('mdb-pdp-float-clear.js'),
          ensureScript('mdb-g-badge-align-v2.js'),
          ensureScript('mdb-pdp-v3.js'),
        ]);
      })
      .then(function () {
        injectSilkType();
        if (typeof window.mdbPdpInit === 'function') window.mdbPdpInit();
      })
      .catch(function (err) {
        console.warn('[mdb-pdp-preview-v5]', err);
        injectSilkType();
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
